import { render } from "./DetailedBoxItem.vue?vue&type=template&id=031d7bf6&scoped=true"
import script from "./DetailedBoxItem.vue?vue&type=script&lang=js"
export * from "./DetailedBoxItem.vue?vue&type=script&lang=js"

import "./DetailedBoxItem.vue?vue&type=style&index=0&id=031d7bf6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031d7bf6"]])

export default __exports__